import type { FormInput, LabelKey, LabelMap, ValidationError } from '../types';

const BIRTHDATE_PATTERN = /^(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/;

const FALLBACK: Record<LabelKey, string> = {
    'error.certNo.required': 'Please enter the certificate number.',
    'error.nameOrBirthdate.required': 'Please enter either the last name or the date of birth.',
    'error.birthdate.format': 'Format: DD.MM.YYYY — e.g. 24.05.1980.',
    'error.serviceUnavailable': 'The verification service is currently unavailable. Please try again later.',
    'error.qrLookup.unavailable':
        'The automatic QR code verification is currently unavailable. Please enter the certificate number together with the last name or the date of birth as printed on the certificate.',
};

export class ValidationService {
    static validate(input: FormInput, labels: LabelMap = {}): ValidationError[] {
        const errors: ValidationError[] = [];
        const certNo = input.certNo.trim();
        const name = input.name.trim();
        const birthdate = input.birthdate.trim();

        if (certNo.length === 0) {
            errors.push({ field: 'certNo', message: this.label(labels, 'error.certNo.required') });
        }

        if (name.length === 0 && birthdate.length === 0) {
            // The ZfP API requires at least one of name/birthdate alongside certNo (data-protection rule).
            // Attached to "name" so it shows under that field; users frequently fill name only.
            errors.push({ field: 'name', message: this.label(labels, 'error.nameOrBirthdate.required') });
        }

        if (birthdate.length > 0 && !BIRTHDATE_PATTERN.test(birthdate)) {
            errors.push({ field: 'birthdate', message: this.label(labels, 'error.birthdate.format') });
        }

        return errors;
    }

    static label(labels: LabelMap, key: LabelKey): string {
        const v = labels[key];
        return v && v.length > 0 ? v : FALLBACK[key];
    }
}
